import api from './api/apiSettings';
import configData from './config.json';

/**
 * Attaches a given access token to a Microsoft Graph API call. Returns information about the user
 */
export async function backendAuth() {
  const endpoint = `${configData.REACT_APP_BACKEND_URL}/api/v1/oauth`;
  return api.get(endpoint);
}

export async function backendUser(userId) {
  const endpoint = `${configData.REACT_APP_BACKEND_URL}/api/v1/User/${userId}`;
  return api.get(endpoint);
}
